<template>
  <div>
    <TopNav />
    <div class="p-10 bg-gray-100 min-h-screen">
      <div class="mx-auto" style="max-width: 1300px; width: 95%;">
        <SiteTitle :title="title" :eyebrow="resolvedEyebrow" />
        <slot />
      </div>
      <BackToTop />
    </div>
  </div>
</template>

<script>
import TopNav from './TopNav.vue';
import SiteTitle from './SiteTitle.vue';
import BackToTop from './BackToTop.vue';

export default {
  name: 'PageShell',
  components: { TopNav, SiteTitle, BackToTop },
  props: {
    // 主标题（已解析文本，如 $t('interface.title.home')）
    title: {
      type: String,
      required: true,
    },
    // 小号 kicker，默认统一为「品牌 · 每周精选」，可覆盖
    eyebrow: {
      type: String,
      default: null,
    },
  },
  computed: {
    resolvedEyebrow() {
      return this.eyebrow || `${this.$t('interface.ai_inspiration_hub')} · ${this.$t('interface.weekly_pick')}`;
    },
  },
};
</script>
